(() => {
  /*
    Cecil & Lou — collection / search scroll UX fix.

    Globo Filter powers the collection + search grids with INFINITE SCROLL and
    rewrites the URL to ?page=N as the shopper scrolls (the shopper never types
    it — Globo writes it). A page then falls into one of two states:

      1. A GENUINE RETURN (tap a product, then Back). If the browser's
         back/forward cache (bfcache) kept the page, it is restored intact —
         every appended page of products AND the exact scroll position. This is
         the only case where "put me back where I was" is actually possible, and
         the browser does it for free.

      2. A FRESH LOAD of a deep ?page=N (refresh, bookmark, shared link, or a
         Back that missed the bfcache). Globo renders ONLY that one page's block
         with nothing above it, then reflows as products + images stream in. The
         old script forced history.scrollRestoration = "manual" and tried to
         re-scroll on timers, which fought that reflow and left shoppers unable
         to reach the top ("stuck — it pushes the page back down"). It also
         never actually restored anything: its logic was gated on a
         `template-collection` <body> class this Dawn theme does not emit.

    Fix, per the chosen behavior ("open clean at the top on a fresh load;
    restore only when I genuinely scrolled there"):

      • Let the browser own restoration. We set scrollRestoration back to
        "auto" and register NO beforeunload/unload listeners (those block the
        bfcache — they are what turned every Back into a broken fresh reload).
        A real Back then restores the whole scrolled page instantly (state 1).

      • On any fresh, non-cached load of a deep ?page=N collection/search URL,
        send the shopper to the clean top of the collection instead of a broken
        deep slice (state 2).

    Blog pagination at /blogs/** is real, shopper-chosen pagination and is left
    completely untouched.
  */

  // Undo any previously-forced manual restoration so the browser restores
  // scroll on cached back/forward navigations again.
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
  } catch (e) {}

  // Surfaces where ?page=N is Globo infinite-scroll state, never a chosen page.
  const isGloboListPath = () =>
    location.pathname.indexOf('/collections/') === 0 || location.pathname === '/search';

  // If the URL carries a deep page (?page=N, N > 1), return the same URL with
  // the page param stripped; otherwise null. Any other query params are kept.
  const cleanDeepPageUrl = () => {
    let url;
    try {
      url = new URL(location.href);
    } catch (e) {
      return null;
    }
    const page = parseInt(url.searchParams.get('page') || '', 10);
    if (!(page > 1)) return null;
    url.searchParams.delete('page');
    return url.pathname + url.search + url.hash;
  };

  const handlePageShow = (fromBFCache) => {
    // A bfcache restore already put the full, scrolled page back — leave it.
    if (fromBFCache) return;
    if (!isGloboListPath()) return;
    const target = cleanDeepPageUrl();
    // location.replace() opens clean at the top and leaves no deep entry in
    // history, so Forward/Back won't bounce back into the broken state.
    if (target) location.replace(target);
  };

  // pageshow fires on first load AND on back/forward; event.persisted === true
  // means it came from the bfcache (a genuine, fully-restored return).
  window.addEventListener('pageshow', (e) => handlePageShow(e.persisted === true));
})();
